<div class="navigation-column-container">
  <div
    (click)="navigate()"
    [ngClass]="disabled && 'disabled-icon'"
    class="link">
    <i class="pi pi-angle-right" aria-hidden="true"></i>
  </div>
</div>
